import { render, staticRenderFns } from "./CreateBasketInfo.vue?vue&type=template&id=df1787c2"
import script from "./CreateBasketInfo.vue?vue&type=script&lang=js"
export * from "./CreateBasketInfo.vue?vue&type=script&lang=js"
import style0 from "./CreateBasketInfo.vue?vue&type=style&index=0&id=df1787c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports